'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var _taxonomies = require('redux/modules/taxonomies');

var _reduxRouter = require('redux-router');

var _components = require('components');

var _reactFullstory = require('react-fullstory');

var _reactFullstory2 = _interopRequireDefault(_reactFullstory);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Authenticated = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    taxonomies: state.taxonomies.taxonomies.data
  };
}, { logout: _auth.logout, push: _reduxRouter.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Authenticated, _Component);

  function Authenticated() {
    (0, _classCallCheck3.default)(this, Authenticated);
    return (0, _possibleConstructorReturn3.default)(this, (Authenticated.__proto__ || (0, _getPrototypeOf2.default)(Authenticated)).apply(this, arguments));
  }

  (0, _createClass3.default)(Authenticated, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;


      if (user) {
        socket.emit('join', user.channel);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (socket && !this.props.user && nextProps.user) {
        socket.emit('join', nextProps.user.channel);
      }
    }
  }, {
    key: 'handleLogout',
    value: function handleLogout(event) {
      event.preventDefault();

      this.props.logout();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          taxonomies = _props.taxonomies,
          user = _props.user;

      var styles = require('./App.scss');
      var locale = user.lang;


      var phrases = require('./../../locales/' + locale + '/app.js');

      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: phrases
      });
      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactDocumentMeta2.default, _config2.default.app),
        _react2.default.createElement(_components.BodyStyle, { style: { backgroundColor: '#FFFFFF' } }),
        _config2.default.fullStoryOrgId && _react2.default.createElement(_reactFullstory2.default, { org: _config2.default.fullStoryOrgId }),
        _react2.default.createElement(
          'div',
          { id: styles.wrapper, className: styles.appContent },
          _react2.default.createElement(_components.Nav, {
            locale: locale,
            logout: this.handleLogout.bind(this),
            polyglot: polyglot,
            taxonomies: taxonomies,
            user: user
          }),
          _react2.default.createElement(
            'div',
            { id: 'page-wrapper' },
            this.props.children
          )
        )
      );
    }
  }], [{
    key: 'fetchData',
    value: function fetchData(getState, dispatch) {
      var promises = [];

      if (!(0, _auth.isLoaded)(getState()) && !(0, _auth.isLoading)(getState())) {
        promises.push(dispatch((0, _auth.load)()));
      }

      if (!(0, _taxonomies.isLoaded)(getState()) && !(0, _taxonomies.isLoading)(getState())) {
        promises.push(dispatch((0, _taxonomies.load)()));
      }

      return _promise2.default.all(promises);
    }
  }]);
  return Authenticated;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.object,
  logout: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired,
  push: _propTypes2.default.func.isRequired,
  taxonomies: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Authenticated;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Authenticated.js
// module id = 2259
// module chunks = 0